module.exports = __webpack_public_path__ + "static/img/4.b9d6a6d.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/gongzhumanghe/4.png
// module id = t5Ic
// module chunks = 1